import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious
} from '@components/ui/carousel';
import { SettingsContainer, SettingsContent } from '@components/ui/settings';
import useProcess from '@hooks/useProcess';
import { ProcessModel } from '@models/process.model';
import type { WorkflowModel } from '@models/workflow.model';
import { ArrowRight } from 'lucide-react';
import { observer } from 'mobx-react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ParamsList } from '@/routes/routes.types';

import { LastGenerations } from './lastgenerations';
import { WorkflowCard, WorkflowCardSkeleton } from './workflowCard';

const ProcessOverview = observer(() => {
  const process = useProcess();
  const processId = useParams()[ParamsList.ProcessId];
  const navigate = useNavigate();

  const renderWorkflows = () => {
    if (!process || process.isSmallProcess || !process.workflows) {
      const workflowIds = ProcessModel.getLocalWorkflowIds(processId);

      if (!workflowIds) {
        return (
          <CarouselItem className="md:basis-1/2 lg:basis-1/3">
            <WorkflowCardSkeleton index={0} />
          </CarouselItem>
        );
      }

      return workflowIds.map((workflowId, index) => (
        <CarouselItem className="md:basis-1/2 lg:basis-1/3" key={workflowId}>
          <WorkflowCardSkeleton index={index} />
        </CarouselItem>
      ));
    }

    return process.workflows.map((workflow: WorkflowModel) => (
      <CarouselItem className="md:basis-1/2 lg:basis-1/3" key={workflow.id}>
        <WorkflowCard key={workflow.id} process={process} workflow={workflow} />
      </CarouselItem>
    ));
  };

  return (
    <SettingsContainer>
      <SettingsContent className="gap-14">
        <section>
          <h2 className="mb-4 font-semibold text-[1.2rem]">Workflows</h2>
          <Carousel className="-mx-3 -my-4" fade>
            <CarouselContent className="h-64 px-3 py-4">
              {renderWorkflows()}
            </CarouselContent>
            <CarouselPrevious />
            <CarouselNext />
          </Carousel>
        </section>
        <section>
          <div className="mb-4 flex items-center justify-between">
            <h2 className="font-semibold text-[1.2rem]">Latest generations</h2>
            <Button
              onClick={() => navigate(`/${processId}/generation`)}
              size="sm"
              variant="outline"
            >
              View all generations
              <ArrowRight />
            </Button>
          </div>
          <LastGenerations processId={processId ?? ''} />
        </section>
      </SettingsContent>
    </SettingsContainer>
  );
});

export default ProcessOverview;
